import BoldSmallText from '@/components/BoldSmallText';
import CheckoutMethodRadio from '@/components/CheckoutMethodRadio';
import { IStateCheckoutRule } from '@/pages/Checkout/components/CreateUpdate';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Card, Text } from '@shopify/polaris';
import { memo, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { PreviewStyled } from './styled';
import useGenerateEstString from '@/hooks/useGenerateEstString';
import { PrefixIcon, PrefixIconColorKeys } from '@/constants/enum';
import { prefixIcons } from '@/constants/icons';
import { prefixIconColors, prefixIconSizes } from '@/constants';
import useShippingMethodSeparator from '@/hooks/useShippingMethodSeparator';

interface IProps {
  children?: any;
  top: number;
  dataCheckout?: IStateCheckoutRule;
}

const PreviewCheckout = ({ dataCheckout, top }: IProps) => {
  const shippingMethodSeparator = useShippingMethodSeparator();
  const dataSettings = useSelector(dataSettingsSelector);
  const generateEstString = useGenerateEstString();

  const [checked, setChecked] = useState(false);

  const estText = generateEstString(
    dataCheckout?.messageText || '',
    dataCheckout?.minPreparationDays,
    dataCheckout?.maxPreparationDays,
    dataCheckout?.minDeliveryDays,
    dataCheckout?.maxDeliveryDays,
  );

  const icon = useMemo(() => {
    if (!dataCheckout) return undefined;
    if (dataCheckout?.iconId === PrefixIcon.none) return undefined;
    else {
      return prefixIcons.find((item) => item.id === dataCheckout?.iconId)?.icon;
    }
  }, [dataCheckout]);

  return (
    <PreviewStyled top={top} generalSetting={dataSettings}>
      <Card padding={'0'}>
        <div className="preview-header">
          <Text as="span" variant="bodyMd">
            CHECKOUT PREVIEW
          </Text>
        </div>
        <div className="preview-content">
          <BoldSmallText>Shipping method</BoldSmallText>
          <CheckoutMethodRadio
            onChange={() => {
              setChecked(!checked);
            }}
            checked={checked}
            estText={estText}
            id={dataCheckout?.id || -1}
            name={dataCheckout?.shippingMethods
              ?.map((item) => item.value)
              .toString()
              .replaceAll(shippingMethodSeparator, ', ')}
            showRadioInput={true}
            data={dataCheckout}
            icon={
              icon
                ? `
                  <div style="min-width: ${prefixIconSizes[dataCheckout?.iconSize || PrefixIconColorKeys.base]}px; min-height: ${
                    prefixIconSizes[dataCheckout?.iconSize || PrefixIconColorKeys.base]
                  }px; display: flex; align-items: center;">
                  ${icon({
                    color: prefixIconColors[dataCheckout?.iconColor || PrefixIconColorKeys.base],
                    size: prefixIconSizes[dataCheckout?.iconSize || PrefixIconColorKeys.base],
                  })}
                  </div>
                `
                : undefined
            }
          />
        </div>
      </Card>
    </PreviewStyled>
  );
};

export default memo(PreviewCheckout);
